import ConfirmedMemberCard from './ConfirmedMemberCard';

export default ConfirmedMemberCard;
